import React, { useState, useEffect, useCallback } from 'react';
import cacheManager from '../CacheManager';
import { formatDate } from '../js/dateFormatter';

const PgRelFinanceiroExtorno = () => {
  // Função para obter o primeiro dia do mês anterior
  const getFirstDayOfPreviousMonth = () => {
    const date = new Date();
    date.setMonth(date.getMonth() - 1);
    date.setDate(1);
    return date.toISOString().split('T')[0];
  };

  // Função para obter o último dia do mês anterior
  const getLastDayOfPreviousMonth = () => {
    const date = new Date();
    date.setMonth(date.getMonth(), 0);
    return date.toISOString().split('T')[0];
  };

  const compareMonthAndDay = (date1, date2) => {
    const month1 = date1.getMonth();
    const day1 = date1.getDate();
    const month2 = date2.getMonth();
    const day2 = date2.getDate();

    if (month1 < month2) return -1;
    if (month1 > month2) return 1;
    if (day1 < day2) return -1;
    if (day1 > day2) return 1;
    return 0;
  };

  const [clientes, setClientes] = useState([]);
  const [dataInicial, setDataInicial] = useState(getFirstDayOfPreviousMonth());
  const [dataFinal, setDataFinal] = useState(getLastDayOfPreviousMonth());
  const [clientesFiltrados, setClientesFiltrados] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const search = useCallback(async () => {
    try {
      setIsLoading(true);
      
      const clientesCache = await cacheManager.getClientesCache();
      setClientes(clientesCache);

    } catch (error) {
      console.error('Erro ao buscar clientes:', error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  // Estilos para esmaecer a página
  const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    zIndex: 2,
    display: isLoading ? 'block' : 'none',
  };

  useEffect(() => {
    search();
  }, [search, dataInicial, dataFinal]);

  useEffect(() => {
    const clientesOrdenados = [...clientes].sort((a, b) => {
      const aX = new Date(a.nascimento);
      const bX = new Date(b.nascimento);

      return compareMonthAndDay(aX, bX);
    });

    const clientesFiltrados = clientesOrdenados.filter(cliente => {
      const dataNascimento = new Date(cliente.nascimento);
      const dataInicialDate = dataInicial ? new Date(dataInicial) : null;
      const dataFinalDate = dataFinal ? new Date(`${dataFinal}T23:59:59`) : null;

      if (dataInicialDate) {
        dataInicialDate.setHours(dataInicialDate.getHours() + 3);
      }
      if (dataFinalDate) {
        dataFinalDate.setHours(dataFinalDate.getHours() + 3);
      }


      if (dataInicialDate && compareMonthAndDay(dataNascimento, dataInicialDate) < 0) {
        return false;
      }

      if (dataFinalDate && compareMonthAndDay(dataNascimento, dataFinalDate) > 0) {
        return false;
      }

      return true;
    });

    setClientesFiltrados(clientesFiltrados);
  }, [clientes, dataInicial, dataFinal]);

  return (
    <div className="container mt-5">
      {isLoading && <div style={overlayStyle}></div>}
      <h2 className="mb-4">Aniversários</h2>
      <div className="input-group mb-3">
        <div className="form-group">
          <label htmlFor="data-inicial">Data Inicial</label>
          <input
            type="date"
            className="form-control"
            id="data-inicial"
            value={dataInicial}
            onChange={(e) => setDataInicial(e.target.value)}
          />
        </div>
        <div className="form-group">
          <label htmlFor="data-final">Data Final</label>
          <input
            type="date"
            className="form-control"
            id="data-final"
            value={dataFinal}
            onChange={(e) => setDataFinal(e.target.value)}
          />
        </div>
      </div>
      <table className="table">
        <thead className="table-light">
          <tr>
            <th>Nº</th>
            <th>Cliente</th>
            <th>Aniversário</th>
          </tr>
        </thead>
        <tbody>
          {clientesFiltrados.map((cliente, index) => (
            <tr key={index} style={{ height: 'auto !important', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              <td>
                  {cliente.id_cliente}
              </td>
              <td>{cliente.nome || 'Cliente não encontrado'}</td>
              <td>{formatDate(cliente.nascimento).slice(0, -3)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PgRelFinanceiroExtorno;